

@if (summaryCollations.length > 0) {
  <ng-contaner>
    @for (item of classes; track item) {
      <div class="form-group form-group--sm mt-30 ml-15 ml-md-0">
        <label class="font-semibold">{{item?.class_name}}</label>
      </div>
      <div class="discount-panel">
        @for (collation of summaryCollations; track collation) {
          @if (collation?.class_id === item?.class_id) {
            <div class="discount-panel__item">
              <div class="discount-panel__heading">
                <div class="discount-panel__heading-name">
                  <strong>{{collation?.description_1?.split('|')[2]}}</strong>
                </div>
                <div class="discount-panel__heading-cost">
                  <p><strong>{{ questionService.accounting.formatMoney(collation?.prem_value)}}</strong> /{{questionService.currency?.display_freq}}</p>
                </div>
              </div>
              <div class="discount-panel__tray">
                <div class="discount-panel__actions">
                  <a href="javascript:void(0);" (click)="editItem(collation)" class="text-link" data-toggle="modal" data-target="#edit-modal">Edit</a>
                  <span>|</span>
                  <a href="javascript:void(0);" (click)="questionService?.setSelectedItem(collation)" class="action-remove text-link">Remove</a>
                </div>
                @if (false) {
                  <div class="tag tag--discount ml-10" id="saved-tag">Saved R 198 /mo</div>
                }
                @if (collation?.discounts !=='') {
                  <div class="discount-panel__discount" style="display: none;">
                    <div class="dropdown">
                      <a href="javascript:void(0);" class="dropdown-toggle dropdown-toggle--nocaret" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <svg class="icon"><use xlink:href="#discount-summary-mini"></use></svg>
                      </a>
                      <div class="dropdown-menu dropdown-menu--discount dropdown-menu-right">
                        <h6>Discounts Earned</h6>
                        @for (discount of collation?.discountList; track discount) {
                          <div class="dropdown-item dropdown-item--discount" >
                            <svg class="icon"><use xlink:href="#discount-summary-mini"></use></svg>
                            <span>{{discount}}</span>
                          </div>
                        }
                      </div>
                    </div>
                    <!-- /.dropdown -->
                  </div>
                }
              </div>
              @if (getRecommendation(collation)?.length > 0) {
                <div class="discount-panel__offers">
                  @for (recommend of getRecommendation(collation); track recommend) {
                    <a href="javascript:void(0);" (click)="popUpRecommendation(recommend)">
                      <div class="discount-panel__offers-icon">
                        <svg class="icon"><use xlink:href="#tag"></use></svg>
                      </div>
                      <div class="discount-panel__offers-name" [innerHTML]="recommend?.header+' '+recommend?.body">
                      </div>
                      <div class="discount-panel__offers-caret">
                        <svg class="icon"><use xlink:href="#chevron-right-small"></use></svg>
                      </div>
                    </a>
                  }
                </div>
              }
            </div>
          }
        }
        <!-- <hr class="hr hr--bdr hr--sm"> -->
        <div class="discount-panel__offers">
          @for (recommend of getRecommendation(item,true); track recommend) {
            <a href="javascript:void(0);" (click)="gotToNext()">
              <div class="discount-panel__offers-icon">
                <svg class="icon"><use xlink:href="#tag"></use></svg>
              </div>
              <div class="discount-panel__offers-name" [innerHTML]="recommend?.header+' '+recommend?.body">
              </div>
              <div class="discount-panel__offers-caret">
                <svg class="icon"><use xlink:href="#chevron-right-small"></use></svg>
              </div>
            </a>
          }
        </div>
      </div>
    }
    @if (checkAddAnother()) {
      <div class="question-panel question-panel--mini">
        <a href="javascript:void(0);" (click)="gotToNext()" class="question-panel__add">
          <div class="button-control">
            <svg class="icon"><use xlink:href="#plus-filled"></use></svg><strong>Add Another Item</strong>
          </div>
        </a>
      </div>
    }
    @if (itk) {
      <div class="itk mt-pageMargin">
        <div class="itk__items">
          <div class="itk__item">
            <div class="itk__item-icon">
              <img src="/assets/0/favicon/favicon-black.svg" class="icon icon--sm" />
            </div>
            <div class="itk__item-content" [innerHTML]="'<strong>Important to know</strong> ' + (itk || '')"></div>
          </div>
        </div>
      </div>
    }
  </ng-contaner>
}

<div class="modal fade modal--alert" id="remove-modal-summary" tabindex="-1" role="dialog"
  aria-labelledby="restart-modal" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-alert modal-alert--alt">
      <div class="modal-alert__heading">
        <div class="container">
          <div class="modal-alert__avatar">
            <img src="assets/{{sessionDetails?.category_id}}/avatar/unsure.png" class="img-fluid" alt="">
          </div>
          <a href="javascript:void(0);" class="modal-alert__close" data-dismiss="modal">
            <svg class="icon">
              <use xlink:href="#close-medium"></use>
            </svg>
          </a>
        </div>
      </div>

      <div class="modal-alert__content">
        <div class="container">
          <div class="rte">
            <h3>Are you sure?</h3>
            <p>You are about to remove {{selectedItem?.description_1.split('|')[2]}}</p>
          </div>
        </div>
      </div>

      <div class="modal-alert__button">
        <div class="container">
          <a href="javascript:;" (click)="questionService?.removeItem()" class="button button--lg button--secondary" data-toggle="modal" data-dismiss="modal">Yes, please do it</a>
          <a href="javascript:;" class="button button--lg button--primary" data-toggle="modal" data-dismiss="modal">No, please don't</a>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal fade modal--alert" id="error-modal" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="error-modal"
  aria-modal="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-alert modal-alert--prorata">
      <div class="modal-alert__heading">
        <div class="container">
          <div class="modal-alert__avatar">
            <img [src]="'assets/0/avatar/sad.png'" alt=""
              class="img-fluid">
            </div>
            <button class="modal-alert__close" data-dismiss="modal">
              <svg class="icon">
                <use xlink:href="#close-circle-small"></use>
              </svg>
            </button>
          </div>
        </div>
        <div class="modal-alert__content">
          <div class="container">
            <div class="rte">
              <h4>Oops!</h4>
              <p class="error-text"></p>
            </div>
          </div>
        </div>
        <div class="modal-alert__button">
          <div class="container">
            <a href="#" class="button button--lg button--primary" data-dismiss="modal">Not cool</a>
          </div>
        </div>
      </div>
    </div>
  </div>
